import { supabase } from './supabase';
import { track } from './analytics';

// Recipient reports ("Report this Yhuu"). Stored via the report_session()
// database function (supabase/reports.sql) — no account needed to report.

export const REPORT_REASONS = [
  { id: 'harassment',    label: 'Harassment or threats' },
  { id: 'unwanted',      label: "I don't want these messages" },
  { id: 'wrong_person',  label: "Wrong person, I don't know them" },
  { id: 'inappropriate', label: 'Sexual or inappropriate' },
  { id: 'scam',          label: 'Scam or fraud' },
  { id: 'other',         label: 'Something else' },
] as const;

export type ReportReason = typeof REPORT_REASONS[number]['id'];
export const reasonLabel = (id: string) => REPORT_REASONS.find(r => r.id === id)?.label ?? id;

export interface ReportInput {
  testId: string;
  reason: ReportReason;
  details?: string;
  contact?: string;
  block?: boolean;
}

export async function submitReport(input: ReportInput): Promise<{ ok: boolean; error?: string }> {
  try {
    const { data, error } = await supabase.rpc('report_session', {
      p_test_id: input.testId,
      p_reason: input.reason,
      p_details: input.details?.trim() || null,
      p_contact: input.contact?.trim() || null,
      p_block: !!input.block,
    });
    if (error) return { ok: false, error: error.message };
    const res = data as { ok?: boolean; id?: number; error?: string } | null;
    if (!res?.ok) return { ok: false, error: res?.error || 'failed' };

    track('report_submitted', { reason: input.reason }, input.testId);

    // Ping the operator's phone. The server decides everything (the report has
    // to exist, and it's only announced once), so this can't be used to spam.
    if (res.id) {
      supabase.functions
        .invoke('send-push', { body: { type: 'admin_new_report', reportId: res.id } })
        .catch(() => {});
    }
    return { ok: true };
  } catch (e: any) {
    return { ok: false, error: e?.message || 'failed' };
  }
}
